export default {
    dashboard: 'Painel',
    business: 'Negócio',
    library: 'Biblioteca',
    drafts: 'Posts',
    calendar: 'Calendário',
    planning: 'Planejamento',
    profile: 'Perfil',
    logout: 'Sair',
};
